package fr.frux.core.maps

import androidx.compose.ui.graphics.Color
import org.maplibre.compose.map.MapUiOptions

// Aucune vue native a arbitrer hors d'Android : seul le voile de chargement est porte ici.
internal actual fun mapUiOptions(
    embedded: Boolean,
    loadColor: Color,
): MapUiOptions = MapUiOptions { this.loadColor = loadColor }
